<template>
  <v-container fluid>
    <HeaderPrint :rev="rev" />
    <TeamPrint :rev="rev" />

    <div class="d-flexalign-center">
      <p
        class="pa-0 my-3 body-2 font-weight-bold blue-grey--text text--darken-3"
      >
        {{ $t('problem_solving.print.problem_definition') }}
      </p>
    </div>

    <div
      class="ma-0 d-flex justify-space-between mb-4"
      style="min-height: 300px"
    >
      <div class="d-flex flex-column" style="width: 49%">
        <StatementPrint
          :paragraph="problemStatement"
          :title="$t('problem_solving.define.problem_label')"
          data-testid="psPrint-paragraph-problemStatement"
        />
        <ImageMediaPrint :mediaObject="problemMediaObject" />
      </div>
      <div class="d-flex flex-column" style="width: 49%">
        <StatementPrint
          :paragraph="containmentPlan"
          :title="$t('problem_solving.problem_analysis.containment_plan')"
          data-testid="psPrint-paragraph-containmentPlan"
        />
        <ImageMediaPrint :mediaObject="countermeasuresMediaObject" />
      </div>
    </div>

    <v-divider class="theme--print" />

    <div class="d-flex justify-space-between mt-4 mb-2">
      <div style="width: 49%">
        <StatementPrint
          data-testid="reviewPrint_statement_goals"
          :minHeight="100"
          :paragraph="goals"
          :title="$t('problem_solving.define.goal_label')"
        />
        <StatementPrint
          :paragraph="businessCase"
          :title="$t('problem_solving.define.business_requirements_label')"
          :minHeight="150"
          data-testid="psPrint-paragraph-businessCase"
        />
      </div>
      <div class="ml-2" style="min-width: 49%;">
        <p class="paragraph font-weight-bold blue-grey--text text--darken-3">
          {{ $t('problem_solving.define.process_map_label') }}
        </p>

        <ImageMediaPrint :mediaObject="processMapMediaObject" />
      </div>
    </div>
  </v-container>
</template>

<script>
import HeaderPrint from './HeaderPrint.vue'
import TeamPrint from './TeamPrint.vue'
import ImageMediaPrint from './ImageMediaPrint.vue'
import StatementPrint from './StatementPrint.vue'

export default {
  name: 'MainPagePrint',
  components: {
    HeaderPrint,
    TeamPrint,
    ImageMediaPrint,
    StatementPrint,
  },

  props: {
    rev: {
      type: Object,
      required: true,
    },
  },

  computed: {
    problemStatement() {
      return this.rev?.problemAnalysis?.problem ?? null
    },
    containmentPlan() {
      return this.rev?.problemAnalysis?.containment ?? ''
    },
    goals() {
      return this.rev?.problemAnalysis?.goals ?? null
    },
    businessCase() {
      return this.rev?.problemAnalysis?.businessRequirements ?? null
    },

    problemMediaObject() {
      return this.rev?.problemAnalysis?.problemMedia?.[0] ?? {}
    },
    countermeasuresMediaObject() {
      return this.rev?.problemAnalysis?.countermeasuresMedia?.[0] ?? {}
    },
    processMapMediaObject() {
      return this.rev?.processMapMedia?.[0] ?? {}
    },
  },
}
</script>
